export default __webpack_public_path__ + "locales/cs/PreparationPortal.json?hash=a6020a98761a9a9a3c5589f56c20d232";